import React, { useEffect, useState } from 'react';
import './styles.css';
import Activity from "../../services/Activity";

export default function Programmation() {
    const [atividades, setAtividades] = useState([]);
    const [opacity, setOpacity] = useState(0);

    function loadActivities(data = '2020-06-03') {
        Activity.readByDate(data).then(response => setAtividades(response))
            .catch(err => {
                alert('Erro ao processar requisição')
                console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
            })
    }

    useEffect(() => {
        loadActivities()
    }, []);

    return (
        <div id="programmation-container">
            <h4 id="text-box">PROGRAMAÇÃO DO EVENTO</h4>

            <div id="event-box">
                <div id="date-box">
                    <h1 className={opacity === 0 ? 'date-box-opacity' : ''} onClick={() => {
                        loadActivities('2020-06-03')
                        setOpacity(0)
                    }}>03</h1>
                    <h1 className={opacity === 1 ? 'date-box-opacity' : ''} onClick={() => {
                        loadActivities('2020-06-04')
                        setOpacity(1)
                    }}>04</h1>
                    <h1 className={opacity === 2 ? 'date-box-opacity' : ''} onClick={() => {
                        loadActivities('2020-06-05')
                        setOpacity(2)
                    }}>05</h1>
                </div>

                <div id="list-box">
                    <ul>
                        {atividades.map(atividade => (
                            <li key={atividade.id}>
                                <a href={atividade.link} rel="noopener noreferrer" target='_blank' className="card">
                                    <h2>{atividade.title}</h2>

                                    <b>Ministrante(s): <span>{atividade.speaker}</span></b>
                                    <br />
                                    <b>Horário: <span>{atividade.hour}</span></b>

                                    <p>{atividade.description}</p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}
